
























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { IAutocompleteOption, TFormValidator } from "@/interfaces";

@Component({
})
export default class RimRepairAutocompleteComponent extends Vue {
  public model = 0;
  @Prop({ default: "value" }) itemValue!: string;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: 0 }) defaultValue!: number;
  @Prop({ default: "" }) label!: string;
	@Prop({ default: "text" }) itemText!: string;
	
  @Prop({ required: true }) searchOptions!: (
    newValue: string | number
	) => Promise<IAutocompleteOption[]>;
	
  public entries: IAutocompleteOption[] = [];
  public loading = false;
  public search = "";
  public debounce!: number;

	Draw(item: any){
		var resu =  eval('item.'+this.itemText);
		return resu;
	}

  mounted() {
    this.model = this.defaultValue;
		this.searchFn("");
  }

  get items() {
    return this.entries;
	}
	
	get loadingColor(): string{
		if (this.loading)return 'info';
		return 'false';
	}

  @Watch("defaultValue", { immediate: true })
  public setValue() {
    this.model = this.defaultValue;
    this.searchFn(String(this.model));
  }

  public searchFn(val: string) {
    clearTimeout(this.debounce);
    this.debounce = setTimeout(() => {
      this.searchAction(val);
    }, 500);
  }

  updateValue(v: number) {
    if (v) this.$emit("updateValue", v);
  }

  searchAction(val: number | string) {
    this.loading = true;
    this.searchOptions(val || "").then((resp) => {
      this.entries = resp;
      this.loading = false;
    });
  }
}


